export enum BatchStatus {
  ARRIVALS = 'arrivals',
  BUFFER = 'buffer',
  INSPECTION = 'inspection',
  ON_STOCK = 'on stock'
}
